/**
 * Dev Console → Fias Plugins.
 *
 * Three blocks: the billing account that pays for every Fias-owned plugin,
 * annexing a developer plugin into Fias ownership, and staffing each
 * Fias-owned plugin's team from an org workspace with Read / Publish. Route is
 * admin-only (`ProtectedRoute requiredRoles={['admin']}` in App.tsx); the
 * server (`requireAdmin` on /v1/admin/plugins) is the authorization boundary.
 * Design + runbook: docs/plugin-annexation.md.
 */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { AnnexPluginCard } from './AnnexPluginCard';
import { FiasPluginBillingCard } from './FiasPluginBillingCard';
import { FiasOwnedPluginsList } from './FiasOwnedPluginsList';

export function PluginAnnexationPage() {
  const [justAnnexed, setJustAnnexed] = React.useState<string | null>(null);

  return (
    <div className="container mx-auto max-w-5xl space-y-6 px-4 py-8">
      <div>
        <Link
          to="/dev-console"
          className="mb-6 inline-block text-sm text-muted-foreground hover:text-foreground"
        >
          ← Back to Dev Console
        </Link>
        <h1 className="text-2xl font-semibold text-foreground">Fias Plugins</h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Choose the account that pays for Fias plugins, annex developer plugins into Fias
          ownership, then choose who on the Fias workspace can read or publish each one.
        </p>
      </div>

      <FiasPluginBillingCard />
      <AnnexPluginCard onAnnexed={setJustAnnexed} />
      <FiasOwnedPluginsList autoOpenArcheId={justAnnexed} />
    </div>
  );
}
